// extracted by mini-css-extract-plugin
module.exports = {"crossed":"crossed___37FZM","red":"red___1ce8A","price":"price___2bsGa","totalTitle":"totalTitle___quowm","shipmentSection":"shipmentSection____pd1j"};